// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page-shell {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  background: #ffffff;
  color: #1f2937;
}

.landing-page-background {
  display: none;
}

.landing-page-header,
.landing-main {
  position: relative;
  z-index: 1;
  width: min(100%, calc(100% - 40px));
  margin: 0 auto;
}

.landing-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 0 18px;
}

.landing-brand {
  display: flex;
  align-items: center;
  gap: 14px;
}

.landing-brand-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.landing-brand-logo {
  width: 28px;
  height: 28px;
}

.landing-brand-title {
  margin: 0;
  font-size: 1.08rem;
  font-weight: 700;
}

.landing-brand-subtitle {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 0.95rem;
}

.landing-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.landing-button,
.landing-link-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 22px;
  border-radius: 10px;
  font-size: 0.98rem;
  font-weight: 600;
  text-decoration: none;
}

.landing-button-secondary {
  border: 1px solid #3B5BDB;
  background: #ffffff;
  color: #0f172a;
}

.landing-link-button {
  border: none;
  background: #3B5BDB;
  color: #ffffff;
}

.landing-main {
  padding-bottom: 0;
}

.landing-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.56fr);
  gap: 48px;
  align-items: start;
  padding: 44px 56px 0;
  background: #eef8f8;
  border-radius: 20px 20px 0 0;
  min-height: 330px;
}

.landing-brand-inline {
  display: none;
}

.landing-inline-logo {
  width: 36px;
  height: 36px;
}

.landing-hero-kicker {
  margin: 28px 0 0;
  color: #1f2937;
  font-size: 1.05rem;
  font-weight: 500;
}

.landing-hero-copy h1 {
  margin: 0;
  font-size: clamp(3.8rem, 6vw, 5.8rem);
  line-height: 0.98;
  letter-spacing: -0.06em;
  font-weight: 700;
}

.landing-hero-copy h1 span {
  background: linear-gradient(90deg, #7dd3fc 0%, #20C997 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.landing-hero-actions,
.landing-hero-note {
  display: none;
}

.landing-hero-visual {
  padding-top: 14px;
}

.landing-intro-panel {
  max-width: 560px;
  margin-left: auto;
}

.landing-intro-text {
  margin: 0;
  color: #6b7280;
  font-size: 1rem;
  line-height: 1.55;
}

.landing-hero-cta-group {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 12px;
}

.landing-inline-cta {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 0 0 8px;
  border: none;
  border-bottom: 2px solid #3B5BDB;
  background: transparent;
  color: #111827;
  font-size: 1.15rem;
  font-weight: 500;
}

.landing-inline-cta.secondary {
  border-bottom-color: #20C997;
}

.landing-showcase {
  position: relative;
  min-height: 610px;
  margin-top: -8px;
  background: #eef8f8;
  border-radius: 0 0 20px 20px;
  overflow: hidden;
}

.landing-wave-pattern {
  position: absolute;
  left: 0;
  bottom: 158px;
  display: grid;
  gap: 14px;
}

.landing-wave-pattern span {
  display: block;
  width: 310px;
  height: 34px;
  border: 5px solid #d3efef;
  border-color: #d3efef transparent transparent transparent;
  border-radius: 48% 48% 0 0;
  transform: rotate(180deg);
}

.landing-spark-shape {
  position: absolute;
  left: 50%;
  top: 78px;
  width: 440px;
  height: 440px;
  background: radial-gradient(circle at center, rgba(59, 91, 219, 0.68) 0%, rgba(59, 91, 219, 0.9) 34%, rgba(59, 91, 219, 0.45) 54%, transparent 56%);
  clip-path: polygon(50% 0%, 60% 40%, 100% 50%, 60% 60%, 50% 100%, 40% 60%, 0% 50%, 40% 40%);
  transform: translateX(-18%);
  filter: blur(0.2px);
  opacity: 0.85;
}

.landing-person-wrap {
  position: absolute;
  left: 50%;
  bottom: -4px;
  transform: translateX(-2%);
  z-index: 2;
}

.landing-person-image {
  display: block;
  width: min(100%, 720px);
  max-height: 760px;
  object-fit: cover;
  object-position: center top;
  border-radius: 24px 24px 0 0;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.1);
}

.landing-profile-card,
.landing-chart-card {
  position: absolute;
  z-index: 3;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(12px);
}

.landing-profile-card {
  left: 460px;
  bottom: 82px;
  width: 230px;
  padding: 18px;
}

.landing-profile-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.landing-profile-top img {
  width: 84px;
  height: 84px;
  object-fit: cover;
  border-radius: 18px;
}

.landing-profile-status {
  display: flex;
  gap: 8px;
}

.landing-profile-status span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 700;
}

.landing-profile-status .success {
  border: 2px solid #22c55e;
  color: #22c55e;
}

.landing-profile-status .danger {
  border: 2px solid #f87171;
  color: #ef4444;
}

.landing-profile-card h3 {
  margin: 12px 0 4px;
  font-size: 1.15rem;
  font-weight: 700;
  color: #111827;
}

.landing-profile-card p {
  margin: 0;
  color: #64748b;
  font-size: 0.92rem;
}

.landing-profile-stars {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}

.landing-profile-stars span {
  width: 16px;
  height: 16px;
  background: #f59e0b;
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
}

.landing-profile-stars .muted {
  background: #cbd5e1;
}

.landing-chart-card {
  right: 476px;
  bottom: 268px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  width: 190px;
  height: 160px;
  padding: 24px 22px;
}

.landing-chart-card .bar {
  width: 14px;
  border-radius: 999px;
  background: #94a3b8;
}

.landing-chart-card .short {
  height: 48px;
  background: #64748b;
}

.landing-chart-card .tiny {
  height: 24px;
  background: #64748b;
}

.landing-chart-card .mid {
  height: 44px;
  background: #64748b;
}

.landing-chart-card .accent {
  height: 70px;
  background: linear-gradient(180deg, #3B5BDB 0%, #20C997 100%);
}

.landing-chart-card .tall {
  height: 96px;
  background: #64748b;
}

@media (max-width: 1400px) {
  .landing-profile-card {
    left: 320px;
  }

  .landing-chart-card {
    right: 300px;
  }
}

@media (max-width: 1100px) {
  .landing-hero {
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 36px 28px 0;
    min-height: auto;
  }

  .landing-hero-visual {
    padding-top: 0;
  }

  .landing-intro-panel {
    margin-left: 0;
  }

  .landing-showcase {
    min-height: 780px;
  }

  .landing-spark-shape {
    left: 50%;
    top: 160px;
    width: 360px;
    height: 360px;
    transform: translateX(-50%);
  }

  .landing-person-wrap {
    left: 50%;
    transform: translateX(-50%);
  }

  .landing-profile-card {
    left: 40px;
    bottom: 82px;
  }

  .landing-chart-card {
    right: 40px;
    bottom: 250px;
  }
}

@media (max-width: 768px) {
  .landing-page-header,
  .landing-main {
    width: calc(100% - 24px);
  }

  .landing-page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .landing-header-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .landing-hero-copy h1 {
    font-size: clamp(3rem, 14vw, 4.5rem);
  }

  .landing-showcase {
    min-height: 780px;
  }

  .landing-wave-pattern {
    left: -90px;
    bottom: 260px;
    transform: scale(0.72);
  }

  .landing-spark-shape {
    top: 212px;
    width: 260px;
    height: 260px;
  }

  .landing-person-image {
    width: 1320px;
    max-height: 1380px;
  }

  .landing-profile-card {
    left: 18px;
    bottom: 100px;
    width: 176px;
    padding: 14px;
  }

  .landing-profile-top img {
    width: 64px;
    height: 64px;
  }

  .landing-chart-card {
    right: 18px;
    bottom: 278px;
    width: 140px;
    height: 122px;
    gap: 8px;
    padding: 18px 16px;
  }

  .landing-chart-card .bar {
    width: 10px;
  }
}

@media (max-width: 520px) {
  .landing-header-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .landing-button,
  .landing-link-button {
    width: 100%;
  }

  .landing-hero {
    padding-left: 20px;
    padding-right: 20px;
  }

  .landing-showcase {
    min-height: 690px;
  }

  .landing-wave-pattern {
    display: none;
  }

  .landing-spark-shape {
    top: 218px;
  }

  .landing-profile-card {
    bottom: 74px;
  }

  .landing-chart-card {
    bottom: 248px;
  }
}

.landing-section-block {
  width: min(100%, calc(100% - 40px));
  margin: 0 auto;
  padding: 48px 0;
}

.landing-trust-strip {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 20px;
  align-items: center;
}

.landing-trust-copy {
  font-size: 1.05rem;
  line-height: 1.5;
  color: #1f2937;
}

.landing-trust-copy span {
  color: #3B5BDB;
  font-weight: 700;
}

.landing-company-list {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  scrollbar-width: none;
}

.landing-company-list::-webkit-scrollbar,
.landing-jobs-row::-webkit-scrollbar,
.landing-testimonial-row::-webkit-scrollbar {
  display: none;
}

.landing-company-list span {
  flex: 0 0 auto;
  padding: 8px 10px;
  border-radius: 6px;
  background: transparent;
  color: #1f2937;
  font-size: 0.94rem;
}

.landing-flow-section {
  display: grid;
  grid-template-columns: minmax(340px, 0.4fr) minmax(460px, 0.6fr);
  gap: 56px;
  align-items: center;
}

.landing-flow-copy h2,
.landing-section-heading h2,
.landing-jobs-head h2,
.landing-testimonials-head h2 {
  margin: 0;
  font-size: clamp(2.5rem, 4vw, 4.2rem);
  line-height: 1.04;
  letter-spacing: -0.05em;
  font-weight: 800;
}

.landing-flow-copy h2 span,
.landing-section-heading h2 span,
.landing-jobs-head h2 span,
.landing-testimonials-head h2 span {
  background: linear-gradient(90deg, #3B5BDB 0%, #20C997 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.landing-accordion-wrap {
  max-width: 680px;
  margin-top: 36px;
}

.landing-accordion-wrap > div {
  counter-reset: flow-step;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.landing-accordion-wrap > div > div {
  border: none !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
  background: transparent !important;
  overflow: visible !important;
}

.landing-accordion-wrap > div > div button {
  padding: 24px 8px 24px 0 !important;
  background: transparent !important;
}

.landing-accordion-wrap > div > div button:hover {
  background: transparent !important;
}

.landing-accordion-wrap > div > div button span {
  display: flex;
  align-items: center;
  gap: 28px;
  font-size: 1.02rem;
  font-weight: 500 !important;
  color: #0f172a;
}

.landing-accordion-wrap > div > div button span::before {
  content: counter(flow-step);
  counter-increment: flow-step;
  min-width: 18px;
  color: #3B5BDB;
  font-weight: 500;
}

.landing-accordion-wrap > div > div button svg {
  color: #0f1f4f !important;
}

.landing-accordion-wrap > div > div > div {
  padding: 0 0 20px 46px !important;
  background: transparent !important;
  color: #64748b !important;
}

.landing-flow-copy {
  position: relative;
}

.landing-toggle-card {
  position: absolute;
  left: calc(100% + 22px);
  top: 62%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 0;
  padding: 14px 24px;
  border: 2px solid #3B5BDB;
  border-radius: 12px;
  background: #020617;
  color: #a5b4fc;
  z-index: 4;
  white-space: nowrap;
  box-shadow: 0 18px 40px rgba(2, 6, 23, 0.14);
}

.landing-toggle-switch {
  position: relative;
  width: 52px;
  height: 28px;
  border: 1px solid #ffffff;
  border-radius: 999px;
  background: #111827;
}

.landing-toggle-switch span {
  position: absolute;
  top: 3px;
  left: 24px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ffffff;
}

.landing-flow-visual {
  background: #eef8f8;
  border-radius: 28px;
  padding: 30px;
  min-height: 620px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.landing-flow-stack {
  position: relative;
  width: min(100%, 560px);
  height: 520px;
}

.landing-flow-card {
  position: absolute;
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(10px);
}

.landing-flow-card.back {
  width: 430px;
  height: 190px;
  padding: 28px;
  opacity: 0.72;
}

.landing-flow-card.back.top {
  top: 0;
  right: 18px;
  overflow: hidden;
}

.landing-flow-card.back.bottom {
  bottom: 0;
  right: 40px;
}

.landing-flow-card.front {
  top: 158px;
  left: -14px;
  width: 520px;
  padding: 22px 28px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.96) 58%, rgba(59, 91, 219, 0.18) 100%);
}

.landing-flow-banner {
  position: absolute;
  inset: 0 0 auto 0;
  height: 84px;
  background:
    radial-gradient(circle at 25% 20%, rgba(34, 211, 238, 0.75), transparent 30%),
    radial-gradient(circle at 82% 10%, rgba(168, 85, 247, 0.5), transparent 36%),
    linear-gradient(90deg, rgba(191, 219, 254, 0.2), rgba(125, 211, 252, 0.32), rgba(216, 180, 254, 0.24));
}

.landing-flow-card-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.landing-flow-card-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 1px solid #dbeafe;
  border-radius: 14px;
  background: #ffffff;
  color: #3B5BDB;
  font-size: 1.45rem;
  font-weight: 700;
  text-transform: lowercase;
}

.landing-flow-card-copy,
.landing-flow-card-title {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 8px;
}

.landing-flow-card-title small,
.landing-flow-footer small {
  color: #94a3b8;
}

.landing-flow-card-title strong,
.landing-flow-card-copy strong {
  font-size: 1rem;
  line-height: 1.35;
  color: #1f2937;
}

.landing-flow-line {
  display: block;
  height: 12px;
  border-radius: 999px;
  background: #edf6f6;
}

.landing-flow-line.long {
  width: 128px;
}

.landing-flow-line.short {
  width: 92px;
}

.landing-flow-bookmark {
  width: 12px;
  height: 18px;
  margin-left: auto;
  border: 2px solid #d4ebe9;
  border-radius: 7px;
}

.landing-flow-bookmark.active {
  border-color: #ffffff;
  background: rgba(255, 255, 255, 0.55);
}

.landing-flow-card-tags {
  display: flex;
  gap: 10px;
  margin-top: 18px;
  padding-left: 60px;
}

.landing-flow-card-tags span {
  display: block;
  width: 54px;
  height: 14px;
  border-radius: 999px;
  background: #edf6f6;
}

.landing-flow-card-tags.faint {
  margin-top: 10px;
  padding-left: 0;
}

.landing-flow-pill-row {
  display: flex;
  gap: 8px;
  margin: 14px 0 20px 60px;
  flex-wrap: wrap;
}

.landing-flow-pill-row span {
  padding: 6px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.68);
  color: #64748b;
  font-size: 0.72rem;
}

.landing-flow-divider {
  height: 1px;
  background: rgba(148, 163, 184, 0.25);
}

.landing-flow-footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
  padding-top: 14px;
}

.landing-flow-footer p {
  margin: 4px 0 0;
  font-size: 0.95rem;
  font-weight: 600;
}

.landing-flow-footer button {
  min-width: 112px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: #3B5BDB;
  color: #ffffff;
  font-weight: 600;
}

.landing-marquee {
  overflow: hidden;
  padding: 18px 0;
  white-space: nowrap;
  background: #020617;
}

.landing-marquee-track {
  display: inline-flex;
  gap: 18px;
  min-width: max-content;
  animation: landing-marquee 26s linear infinite;
  font-size: clamp(2rem, 3vw, 3rem);
  font-weight: 700;
  color: #ffffff;
}

.landing-marquee-track .accent {
  color: #20C997;
}

@keyframes landing-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-33%);
  }
}

.landing-section-heading {
  text-align: center;
}

.landing-section-heading p,
.landing-jobs-head p,
.landing-testimonials-head p {
  max-width: 820px;
  margin: 16px auto 0;
  color: #334155;
  font-size: 1.05rem;
  line-height: 1.55;
}

.landing-benefits-panel {
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  margin-top: 40px;
  padding: 40px 26px 28px;
  border-radius: 24px;
  background: linear-gradient(90deg, #eef0fb 0%, #d6f5ed 100%);
  overflow: hidden;
}

.landing-benefits-art {
  position: absolute;
  top: 0;
  right: 0;
  width: 340px;
  opacity: 0.9;
}

.landing-benefit-card {
  position: relative;
  z-index: 1;
  min-height: 206px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(8px);
}

.landing-benefit-card img {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  object-fit: cover;
}

.landing-benefit-card h3 {
  margin: 18px 0 14px;
  font-size: 1.15rem;
}

.landing-benefit-card p {
  margin: 0;
  color: #334155;
  line-height: 1.5;
}

.landing-jobs-head,
.landing-testimonials-head,
.landing-footer-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.landing-nav-buttons {
  display: flex;
  gap: 14px;
}

.landing-nav-buttons.center {
  justify-content: center;
  margin-top: 26px;
}

.landing-nav-buttons button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: #eef0fb;
  color: #3B5BDB;
}

.landing-jobs-row,
.landing-testimonial-row {
  display: flex;
  gap: 22px;
  margin-top: 28px;
  overflow-x: auto;
  scroll-behavior: smooth;
}

.landing-job-card,
.landing-testimonial-card {
  flex: 0 0 auto;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
}

.landing-job-card {
  width: 280px;
  padding: 22px 22px 18px;
  border-radius: 18px;
}

.landing-job-card img {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  object-fit: cover;
}

.landing-job-company {
  margin: 18px 0 10px;
  color: #94a3b8;
  font-size: 0.92rem;
}

.landing-job-card h3 {
  margin: 0;
  font-size: 1rem;
  line-height: 1.45;
}

.landing-job-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #e2e8f0;
}

.landing-job-meta span {
  padding: 6px 10px;
  border-radius: 999px;
  background: #f8fafc;
  color: #64748b;
  font-size: 0.82rem;
}

.landing-testimonials-panel {
  position: relative;
  margin-top: 28px;
  padding: 0 0 30px;
  border-radius: 22px;
  background: linear-gradient(180deg, #ffffff 0%, #bdefff 140%);
  overflow: hidden;
}

.landing-testimonial-art {
  position: absolute;
  top: 0;
  right: 0;
  width: 290px;
  opacity: 0.95;
}

.landing-testimonial-row {
  position: relative;
  z-index: 1;
  padding: 130px 30px 0;
}

.landing-testimonial-card {
  width: 360px;
  min-height: 280px;
  padding: 26px 24px;
  border-radius: 16px;
}

.landing-stars {
  display: flex;
  gap: 6px;
  color: #fbbf24;
}

.landing-stars .muted {
  color: #cbd5e1;
}

.landing-testimonial-card p {
  margin: 18px 0 24px;
  font-size: 0.98rem;
  line-height: 1.55;
}

.landing-review-author {
  display: flex;
  align-items: center;
  gap: 14px;
}

.landing-review-author img {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  object-fit: cover;
}

.landing-review-author strong,
.landing-review-author span {
  display: block;
}

.landing-review-author span {
  margin-top: 4px;
  color: #94a3b8;
}

.landing-footer {
  margin-top: 0;
  padding: 36px 20px 0;
  background: #000000;
  color: #ffffff;
}

.landing-footer-copy {
  max-width: 480px;
  margin: 0;
  color: #94a3b8;
  line-height: 1.55;
}

.landing-socials {
  display: flex;
  gap: 14px;
  margin-top: 34px;
}

.landing-socials a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.landing-socials img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.landing-contact-block h3 {
  margin: 0 0 18px;
  font-size: 1.8rem;
}

.landing-contact-block p {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #cbd5e1;
}

.landing-footer-bottom {
  padding: 32px 0 18px;
  text-align: center;
  color: #94a3b8;
}

@media (max-width: 1100px) {
  .landing-trust-strip,
  .landing-flow-section,
  .landing-benefits-panel {
    grid-template-columns: 1fr;
  }

  .landing-benefits-art,
  .landing-testimonial-art {
    width: 220px;
  }

  .landing-jobs-head,
  .landing-testimonials-head,
  .landing-footer-top {
    flex-direction: column;
  }

  .landing-company-list {
    padding-bottom: 6px;
  }

  .landing-flow-section {
    gap: 30px;
  }

  .landing-flow-visual {
    min-height: 520px;
  }

  .landing-flow-stack {
    height: 440px;
  }

  .landing-flow-card.front {
    left: 0;
    width: calc(100% - 10px);
  }

  .landing-flow-card.back {
    width: calc(100% - 80px);
  }

  .landing-toggle-card {
    position: static;
    transform: none;
    margin-top: 24px;
  }
}

@media (max-width: 768px) {
  .landing-section-block {
    width: calc(100% - 24px);
    padding: 34px 0;
  }

  .landing-benefits-panel {
    padding: 28px 16px 16px;
  }

  .landing-flow-visual {
    min-height: 420px;
    padding: 18px;
  }

  .landing-flow-stack {
    height: 360px;
  }

  .landing-flow-card.back {
    width: calc(100% - 36px);
    height: 132px;
    padding: 18px;
  }

  .landing-flow-card.front {
    top: 112px;
    width: 100%;
    padding: 16px 18px;
  }

  .landing-flow-card.back.bottom {
    right: 18px;
  }

  .landing-toggle-card {
    padding: 12px 18px;
    font-size: 0.95rem;
  }

  .landing-flow-card-title strong,
  .landing-flow-card-copy strong {
    font-size: 0.88rem;
  }

  .landing-flow-pill-row {
    margin-left: 0;
  }

  .landing-flow-card-tags {
    padding-left: 0;
  }

  .landing-flow-footer {
    flex-direction: column;
    align-items: flex-start;
  }

  .landing-benefits-art {
    display: none;
  }

  .landing-testimonial-row {
    padding: 100px 16px 0;
  }

  .landing-testimonial-card,
  .landing-job-card {
    width: min(84vw, 320px);
  }

  .landing-footer {
    padding-left: 12px;
    padding-right: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LandingPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;EAC5D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,yDAAyD;EACzD,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mJAAmJ;EACnJ,0FAA0F;EAC1F,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0GAA0G;AAC5G;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gEAAgE;EAChE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;EAIE,SAAS;EACT,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;EAIE,4DAA4D;EAC5D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,2BAA2B;EAC3B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,aAAa;AACf;;AAEA;EACE,MAAM;EACN,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+FAA+F;AACjG;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ;;;0GAGwG;AAC1G;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,sBAAsB;EACtB,8CAA8C;EAC9C,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,4DAA4D;EAC5D,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;;IAEE,YAAY;EACd;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,OAAO;IACP,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":[".landing-page-shell {\n  position: relative;\n  min-height: 100vh;\n  overflow-x: hidden;\n  background: #ffffff;\n  color: #1f2937;\n}\n\n.landing-page-background {\n  display: none;\n}\n\n.landing-page-header,\n.landing-main {\n  position: relative;\n  z-index: 1;\n  width: min(100%, calc(100% - 40px));\n  margin: 0 auto;\n}\n\n.landing-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  padding: 24px 0 18px;\n}\n\n.landing-brand {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.landing-brand-mark {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);\n}\n\n.landing-brand-logo {\n  width: 28px;\n  height: 28px;\n}\n\n.landing-brand-title {\n  margin: 0;\n  font-size: 1.08rem;\n  font-weight: 700;\n}\n\n.landing-brand-subtitle {\n  margin: 4px 0 0;\n  color: #64748b;\n  font-size: 0.95rem;\n}\n\n.landing-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.landing-button,\n.landing-link-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 0 22px;\n  border-radius: 10px;\n  font-size: 0.98rem;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.landing-button-secondary {\n  border: 1px solid #3B5BDB;\n  background: #ffffff;\n  color: #0f172a;\n}\n\n.landing-link-button {\n  border: none;\n  background: #3B5BDB;\n  color: #ffffff;\n}\n\n.landing-main {\n  padding-bottom: 0;\n}\n\n.landing-hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.56fr);\n  gap: 48px;\n  align-items: start;\n  padding: 44px 56px 0;\n  background: #eef8f8;\n  border-radius: 20px 20px 0 0;\n  min-height: 330px;\n}\n\n.landing-brand-inline {\n  display: none;\n}\n\n.landing-inline-logo {\n  width: 36px;\n  height: 36px;\n}\n\n.landing-hero-kicker {\n  margin: 28px 0 0;\n  color: #1f2937;\n  font-size: 1.05rem;\n  font-weight: 500;\n}\n\n.landing-hero-copy h1 {\n  margin: 0;\n  font-size: clamp(3.8rem, 6vw, 5.8rem);\n  line-height: 0.98;\n  letter-spacing: -0.06em;\n  font-weight: 700;\n}\n\n.landing-hero-copy h1 span {\n  background: linear-gradient(90deg, #7dd3fc 0%, #20C997 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.landing-hero-actions,\n.landing-hero-note {\n  display: none;\n}\n\n.landing-hero-visual {\n  padding-top: 14px;\n}\n\n.landing-intro-panel {\n  max-width: 560px;\n  margin-left: auto;\n}\n\n.landing-intro-text {\n  margin: 0;\n  color: #6b7280;\n  font-size: 1rem;\n  line-height: 1.55;\n}\n\n.landing-hero-cta-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 12px;\n}\n\n.landing-inline-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 0 8px;\n  border: none;\n  border-bottom: 2px solid #3B5BDB;\n  background: transparent;\n  color: #111827;\n  font-size: 1.15rem;\n  font-weight: 500;\n}\n\n.landing-inline-cta.secondary {\n  border-bottom-color: #20C997;\n}\n\n.landing-showcase {\n  position: relative;\n  min-height: 610px;\n  margin-top: -8px;\n  background: #eef8f8;\n  border-radius: 0 0 20px 20px;\n  overflow: hidden;\n}\n\n.landing-wave-pattern {\n  position: absolute;\n  left: 0;\n  bottom: 158px;\n  display: grid;\n  gap: 14px;\n}\n\n.landing-wave-pattern span {\n  display: block;\n  width: 310px;\n  height: 34px;\n  border: 5px solid #d3efef;\n  border-color: #d3efef transparent transparent transparent;\n  border-radius: 48% 48% 0 0;\n  transform: rotate(180deg);\n}\n\n.landing-spark-shape {\n  position: absolute;\n  left: 50%;\n  top: 78px;\n  width: 440px;\n  height: 440px;\n  background: radial-gradient(circle at center, rgba(59, 91, 219, 0.68) 0%, rgba(59, 91, 219, 0.9) 34%, rgba(59, 91, 219, 0.45) 54%, transparent 56%);\n  clip-path: polygon(50% 0%, 60% 40%, 100% 50%, 60% 60%, 50% 100%, 40% 60%, 0% 50%, 40% 40%);\n  transform: translateX(-18%);\n  filter: blur(0.2px);\n  opacity: 0.85;\n}\n\n.landing-person-wrap {\n  position: absolute;\n  left: 50%;\n  bottom: -4px;\n  transform: translateX(-2%);\n  z-index: 2;\n}\n\n.landing-person-image {\n  display: block;\n  width: min(100%, 720px);\n  max-height: 760px;\n  object-fit: cover;\n  object-position: center top;\n  border-radius: 24px 24px 0 0;\n  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.1);\n}\n\n.landing-profile-card,\n.landing-chart-card {\n  position: absolute;\n  z-index: 3;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(12px);\n}\n\n.landing-profile-card {\n  left: 460px;\n  bottom: 82px;\n  width: 230px;\n  padding: 18px;\n}\n\n.landing-profile-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.landing-profile-top img {\n  width: 84px;\n  height: 84px;\n  object-fit: cover;\n  border-radius: 18px;\n}\n\n.landing-profile-status {\n  display: flex;\n  gap: 8px;\n}\n\n.landing-profile-status span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 999px;\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.landing-profile-status .success {\n  border: 2px solid #22c55e;\n  color: #22c55e;\n}\n\n.landing-profile-status .danger {\n  border: 2px solid #f87171;\n  color: #ef4444;\n}\n\n.landing-profile-card h3 {\n  margin: 12px 0 4px;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #111827;\n}\n\n.landing-profile-card p {\n  margin: 0;\n  color: #64748b;\n  font-size: 0.92rem;\n}\n\n.landing-profile-stars {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.landing-profile-stars span {\n  width: 16px;\n  height: 16px;\n  background: #f59e0b;\n  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);\n}\n\n.landing-profile-stars .muted {\n  background: #cbd5e1;\n}\n\n.landing-chart-card {\n  right: 476px;\n  bottom: 268px;\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  width: 190px;\n  height: 160px;\n  padding: 24px 22px;\n}\n\n.landing-chart-card .bar {\n  width: 14px;\n  border-radius: 999px;\n  background: #94a3b8;\n}\n\n.landing-chart-card .short {\n  height: 48px;\n  background: #64748b;\n}\n\n.landing-chart-card .tiny {\n  height: 24px;\n  background: #64748b;\n}\n\n.landing-chart-card .mid {\n  height: 44px;\n  background: #64748b;\n}\n\n.landing-chart-card .accent {\n  height: 70px;\n  background: linear-gradient(180deg, #3B5BDB 0%, #20C997 100%);\n}\n\n.landing-chart-card .tall {\n  height: 96px;\n  background: #64748b;\n}\n\n@media (max-width: 1400px) {\n  .landing-profile-card {\n    left: 320px;\n  }\n\n  .landing-chart-card {\n    right: 300px;\n  }\n}\n\n@media (max-width: 1100px) {\n  .landing-hero {\n    grid-template-columns: 1fr;\n    gap: 28px;\n    padding: 36px 28px 0;\n    min-height: auto;\n  }\n\n  .landing-hero-visual {\n    padding-top: 0;\n  }\n\n  .landing-intro-panel {\n    margin-left: 0;\n  }\n\n  .landing-showcase {\n    min-height: 780px;\n  }\n\n  .landing-spark-shape {\n    left: 50%;\n    top: 160px;\n    width: 360px;\n    height: 360px;\n    transform: translateX(-50%);\n  }\n\n  .landing-person-wrap {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  .landing-profile-card {\n    left: 40px;\n    bottom: 82px;\n  }\n\n  .landing-chart-card {\n    right: 40px;\n    bottom: 250px;\n  }\n}\n\n@media (max-width: 768px) {\n  .landing-page-header,\n  .landing-main {\n    width: calc(100% - 24px);\n  }\n\n  .landing-page-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .landing-header-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .landing-hero-copy h1 {\n    font-size: clamp(3rem, 14vw, 4.5rem);\n  }\n\n  .landing-showcase {\n    min-height: 780px;\n  }\n\n  .landing-wave-pattern {\n    left: -90px;\n    bottom: 260px;\n    transform: scale(0.72);\n  }\n\n  .landing-spark-shape {\n    top: 212px;\n    width: 260px;\n    height: 260px;\n  }\n\n  .landing-person-image {\n    width: 1320px;\n    max-height: 1380px;\n  }\n\n  .landing-profile-card {\n    left: 18px;\n    bottom: 100px;\n    width: 176px;\n    padding: 14px;\n  }\n\n  .landing-profile-top img {\n    width: 64px;\n    height: 64px;\n  }\n\n  .landing-chart-card {\n    right: 18px;\n    bottom: 278px;\n    width: 140px;\n    height: 122px;\n    gap: 8px;\n    padding: 18px 16px;\n  }\n\n  .landing-chart-card .bar {\n    width: 10px;\n  }\n}\n\n@media (max-width: 520px) {\n  .landing-header-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .landing-button,\n  .landing-link-button {\n    width: 100%;\n  }\n\n  .landing-hero {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .landing-showcase {\n    min-height: 690px;\n  }\n\n  .landing-wave-pattern {\n    display: none;\n  }\n\n  .landing-spark-shape {\n    top: 218px;\n  }\n\n  .landing-profile-card {\n    bottom: 74px;\n  }\n\n  .landing-chart-card {\n    bottom: 248px;\n  }\n}\n\n.landing-section-block {\n  width: min(100%, calc(100% - 40px));\n  margin: 0 auto;\n  padding: 48px 0;\n}\n\n.landing-trust-strip {\n  display: grid;\n  grid-template-columns: 220px minmax(0, 1fr);\n  gap: 20px;\n  align-items: center;\n}\n\n.landing-trust-copy {\n  font-size: 1.05rem;\n  line-height: 1.5;\n  color: #1f2937;\n}\n\n.landing-trust-copy span {\n  color: #3B5BDB;\n  font-weight: 700;\n}\n\n.landing-company-list {\n  display: flex;\n  gap: 16px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.landing-company-list::-webkit-scrollbar,\n.landing-jobs-row::-webkit-scrollbar,\n.landing-testimonial-row::-webkit-scrollbar {\n  display: none;\n}\n\n.landing-company-list span {\n  flex: 0 0 auto;\n  padding: 8px 10px;\n  border-radius: 6px;\n  background: transparent;\n  color: #1f2937;\n  font-size: 0.94rem;\n}\n\n.landing-flow-section {\n  display: grid;\n  grid-template-columns: minmax(340px, 0.4fr) minmax(460px, 0.6fr);\n  gap: 56px;\n  align-items: center;\n}\n\n.landing-flow-copy h2,\n.landing-section-heading h2,\n.landing-jobs-head h2,\n.landing-testimonials-head h2 {\n  margin: 0;\n  font-size: clamp(2.5rem, 4vw, 4.2rem);\n  line-height: 1.04;\n  letter-spacing: -0.05em;\n  font-weight: 800;\n}\n\n.landing-flow-copy h2 span,\n.landing-section-heading h2 span,\n.landing-jobs-head h2 span,\n.landing-testimonials-head h2 span {\n  background: linear-gradient(90deg, #3B5BDB 0%, #20C997 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.landing-accordion-wrap {\n  max-width: 680px;\n  margin-top: 36px;\n}\n\n.landing-accordion-wrap > div {\n  counter-reset: flow-step;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.landing-accordion-wrap > div > div {\n  border: none !important;\n  border-bottom: 1px solid #e5e7eb !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  overflow: visible !important;\n}\n\n.landing-accordion-wrap > div > div button {\n  padding: 24px 8px 24px 0 !important;\n  background: transparent !important;\n}\n\n.landing-accordion-wrap > div > div button:hover {\n  background: transparent !important;\n}\n\n.landing-accordion-wrap > div > div button span {\n  display: flex;\n  align-items: center;\n  gap: 28px;\n  font-size: 1.02rem;\n  font-weight: 500 !important;\n  color: #0f172a;\n}\n\n.landing-accordion-wrap > div > div button span::before {\n  content: counter(flow-step);\n  counter-increment: flow-step;\n  min-width: 18px;\n  color: #3B5BDB;\n  font-weight: 500;\n}\n\n.landing-accordion-wrap > div > div button svg {\n  color: #0f1f4f !important;\n}\n\n.landing-accordion-wrap > div > div > div {\n  padding: 0 0 20px 46px !important;\n  background: transparent !important;\n  color: #64748b !important;\n}\n\n.landing-flow-copy {\n  position: relative;\n}\n\n.landing-toggle-card {\n  position: absolute;\n  left: calc(100% + 22px);\n  top: 62%;\n  transform: translate(-50%, -50%);\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 0;\n  padding: 14px 24px;\n  border: 2px solid #3B5BDB;\n  border-radius: 12px;\n  background: #020617;\n  color: #a5b4fc;\n  z-index: 4;\n  white-space: nowrap;\n  box-shadow: 0 18px 40px rgba(2, 6, 23, 0.14);\n}\n\n.landing-toggle-switch {\n  position: relative;\n  width: 52px;\n  height: 28px;\n  border: 1px solid #ffffff;\n  border-radius: 999px;\n  background: #111827;\n}\n\n.landing-toggle-switch span {\n  position: absolute;\n  top: 3px;\n  left: 24px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #ffffff;\n}\n\n.landing-flow-visual {\n  background: #eef8f8;\n  border-radius: 28px;\n  padding: 30px;\n  min-height: 620px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.landing-flow-stack {\n  position: relative;\n  width: min(100%, 560px);\n  height: 520px;\n}\n\n.landing-flow-card {\n  position: absolute;\n  border-radius: 26px;\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(10px);\n}\n\n.landing-flow-card.back {\n  width: 430px;\n  height: 190px;\n  padding: 28px;\n  opacity: 0.72;\n}\n\n.landing-flow-card.back.top {\n  top: 0;\n  right: 18px;\n  overflow: hidden;\n}\n\n.landing-flow-card.back.bottom {\n  bottom: 0;\n  right: 40px;\n}\n\n.landing-flow-card.front {\n  top: 158px;\n  left: -14px;\n  width: 520px;\n  padding: 22px 28px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.96) 58%, rgba(59, 91, 219, 0.18) 100%);\n}\n\n.landing-flow-banner {\n  position: absolute;\n  inset: 0 0 auto 0;\n  height: 84px;\n  background:\n    radial-gradient(circle at 25% 20%, rgba(34, 211, 238, 0.75), transparent 30%),\n    radial-gradient(circle at 82% 10%, rgba(168, 85, 247, 0.5), transparent 36%),\n    linear-gradient(90deg, rgba(191, 219, 254, 0.2), rgba(125, 211, 252, 0.32), rgba(216, 180, 254, 0.24));\n}\n\n.landing-flow-card-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.landing-flow-card-logo {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border: 1px solid #dbeafe;\n  border-radius: 14px;\n  background: #ffffff;\n  color: #3B5BDB;\n  font-size: 1.45rem;\n  font-weight: 700;\n  text-transform: lowercase;\n}\n\n.landing-flow-card-copy,\n.landing-flow-card-title {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.landing-flow-card-title small,\n.landing-flow-footer small {\n  color: #94a3b8;\n}\n\n.landing-flow-card-title strong,\n.landing-flow-card-copy strong {\n  font-size: 1rem;\n  line-height: 1.35;\n  color: #1f2937;\n}\n\n.landing-flow-line {\n  display: block;\n  height: 12px;\n  border-radius: 999px;\n  background: #edf6f6;\n}\n\n.landing-flow-line.long {\n  width: 128px;\n}\n\n.landing-flow-line.short {\n  width: 92px;\n}\n\n.landing-flow-bookmark {\n  width: 12px;\n  height: 18px;\n  margin-left: auto;\n  border: 2px solid #d4ebe9;\n  border-radius: 7px;\n}\n\n.landing-flow-bookmark.active {\n  border-color: #ffffff;\n  background: rgba(255, 255, 255, 0.55);\n}\n\n.landing-flow-card-tags {\n  display: flex;\n  gap: 10px;\n  margin-top: 18px;\n  padding-left: 60px;\n}\n\n.landing-flow-card-tags span {\n  display: block;\n  width: 54px;\n  height: 14px;\n  border-radius: 999px;\n  background: #edf6f6;\n}\n\n.landing-flow-card-tags.faint {\n  margin-top: 10px;\n  padding-left: 0;\n}\n\n.landing-flow-pill-row {\n  display: flex;\n  gap: 8px;\n  margin: 14px 0 20px 60px;\n  flex-wrap: wrap;\n}\n\n.landing-flow-pill-row span {\n  padding: 6px 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.68);\n  color: #64748b;\n  font-size: 0.72rem;\n}\n\n.landing-flow-divider {\n  height: 1px;\n  background: rgba(148, 163, 184, 0.25);\n}\n\n.landing-flow-footer {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 18px;\n  padding-top: 14px;\n}\n\n.landing-flow-footer p {\n  margin: 4px 0 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.landing-flow-footer button {\n  min-width: 112px;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  background: #3B5BDB;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.landing-marquee {\n  overflow: hidden;\n  padding: 18px 0;\n  white-space: nowrap;\n  background: #020617;\n}\n\n.landing-marquee-track {\n  display: inline-flex;\n  gap: 18px;\n  min-width: max-content;\n  animation: landing-marquee 26s linear infinite;\n  font-size: clamp(2rem, 3vw, 3rem);\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.landing-marquee-track .accent {\n  color: #20C997;\n}\n\n@keyframes landing-marquee {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-33%);\n  }\n}\n\n.landing-section-heading {\n  text-align: center;\n}\n\n.landing-section-heading p,\n.landing-jobs-head p,\n.landing-testimonials-head p {\n  max-width: 820px;\n  margin: 16px auto 0;\n  color: #334155;\n  font-size: 1.05rem;\n  line-height: 1.55;\n}\n\n.landing-benefits-panel {\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n  margin-top: 40px;\n  padding: 40px 26px 28px;\n  border-radius: 24px;\n  background: linear-gradient(90deg, #eef0fb 0%, #d6f5ed 100%);\n  overflow: hidden;\n}\n\n.landing-benefits-art {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 340px;\n  opacity: 0.9;\n}\n\n.landing-benefit-card {\n  position: relative;\n  z-index: 1;\n  min-height: 206px;\n  padding: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.9);\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.28);\n  backdrop-filter: blur(8px);\n}\n\n.landing-benefit-card img {\n  width: 50px;\n  height: 50px;\n  border-radius: 12px;\n  object-fit: cover;\n}\n\n.landing-benefit-card h3 {\n  margin: 18px 0 14px;\n  font-size: 1.15rem;\n}\n\n.landing-benefit-card p {\n  margin: 0;\n  color: #334155;\n  line-height: 1.5;\n}\n\n.landing-jobs-head,\n.landing-testimonials-head,\n.landing-footer-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.landing-nav-buttons {\n  display: flex;\n  gap: 14px;\n}\n\n.landing-nav-buttons.center {\n  justify-content: center;\n  margin-top: 26px;\n}\n\n.landing-nav-buttons button {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 8px;\n  background: #eef0fb;\n  color: #3B5BDB;\n}\n\n.landing-jobs-row,\n.landing-testimonial-row {\n  display: flex;\n  gap: 22px;\n  margin-top: 28px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n}\n\n.landing-job-card,\n.landing-testimonial-card {\n  flex: 0 0 auto;\n  background: #ffffff;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);\n}\n\n.landing-job-card {\n  width: 280px;\n  padding: 22px 22px 18px;\n  border-radius: 18px;\n}\n\n.landing-job-card img {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  object-fit: cover;\n}\n\n.landing-job-company {\n  margin: 18px 0 10px;\n  color: #94a3b8;\n  font-size: 0.92rem;\n}\n\n.landing-job-card h3 {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.45;\n}\n\n.landing-job-meta {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.landing-job-meta span {\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 0.82rem;\n}\n\n.landing-testimonials-panel {\n  position: relative;\n  margin-top: 28px;\n  padding: 0 0 30px;\n  border-radius: 22px;\n  background: linear-gradient(180deg, #ffffff 0%, #bdefff 140%);\n  overflow: hidden;\n}\n\n.landing-testimonial-art {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 290px;\n  opacity: 0.95;\n}\n\n.landing-testimonial-row {\n  position: relative;\n  z-index: 1;\n  padding: 130px 30px 0;\n}\n\n.landing-testimonial-card {\n  width: 360px;\n  min-height: 280px;\n  padding: 26px 24px;\n  border-radius: 16px;\n}\n\n.landing-stars {\n  display: flex;\n  gap: 6px;\n  color: #fbbf24;\n}\n\n.landing-stars .muted {\n  color: #cbd5e1;\n}\n\n.landing-testimonial-card p {\n  margin: 18px 0 24px;\n  font-size: 0.98rem;\n  line-height: 1.55;\n}\n\n.landing-review-author {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.landing-review-author img {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  object-fit: cover;\n}\n\n.landing-review-author strong,\n.landing-review-author span {\n  display: block;\n}\n\n.landing-review-author span {\n  margin-top: 4px;\n  color: #94a3b8;\n}\n\n.landing-footer {\n  margin-top: 0;\n  padding: 36px 20px 0;\n  background: #000000;\n  color: #ffffff;\n}\n\n.landing-footer-copy {\n  max-width: 480px;\n  margin: 0;\n  color: #94a3b8;\n  line-height: 1.55;\n}\n\n.landing-socials {\n  display: flex;\n  gap: 14px;\n  margin-top: 34px;\n}\n\n.landing-socials a {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n}\n\n.landing-socials img {\n  width: 22px;\n  height: 22px;\n  object-fit: contain;\n}\n\n.landing-contact-block h3 {\n  margin: 0 0 18px;\n  font-size: 1.8rem;\n}\n\n.landing-contact-block p {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #cbd5e1;\n}\n\n.landing-footer-bottom {\n  padding: 32px 0 18px;\n  text-align: center;\n  color: #94a3b8;\n}\n\n@media (max-width: 1100px) {\n  .landing-trust-strip,\n  .landing-flow-section,\n  .landing-benefits-panel {\n    grid-template-columns: 1fr;\n  }\n\n  .landing-benefits-art,\n  .landing-testimonial-art {\n    width: 220px;\n  }\n\n  .landing-jobs-head,\n  .landing-testimonials-head,\n  .landing-footer-top {\n    flex-direction: column;\n  }\n\n  .landing-company-list {\n    padding-bottom: 6px;\n  }\n\n  .landing-flow-section {\n    gap: 30px;\n  }\n\n  .landing-flow-visual {\n    min-height: 520px;\n  }\n\n  .landing-flow-stack {\n    height: 440px;\n  }\n\n  .landing-flow-card.front {\n    left: 0;\n    width: calc(100% - 10px);\n  }\n\n  .landing-flow-card.back {\n    width: calc(100% - 80px);\n  }\n\n  .landing-toggle-card {\n    position: static;\n    transform: none;\n    margin-top: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .landing-section-block {\n    width: calc(100% - 24px);\n    padding: 34px 0;\n  }\n\n  .landing-benefits-panel {\n    padding: 28px 16px 16px;\n  }\n\n  .landing-flow-visual {\n    min-height: 420px;\n    padding: 18px;\n  }\n\n  .landing-flow-stack {\n    height: 360px;\n  }\n\n  .landing-flow-card.back {\n    width: calc(100% - 36px);\n    height: 132px;\n    padding: 18px;\n  }\n\n  .landing-flow-card.front {\n    top: 112px;\n    width: 100%;\n    padding: 16px 18px;\n  }\n\n  .landing-flow-card.back.bottom {\n    right: 18px;\n  }\n\n  .landing-toggle-card {\n    padding: 12px 18px;\n    font-size: 0.95rem;\n  }\n\n  .landing-flow-card-title strong,\n  .landing-flow-card-copy strong {\n    font-size: 0.88rem;\n  }\n\n  .landing-flow-pill-row {\n    margin-left: 0;\n  }\n\n  .landing-flow-card-tags {\n    padding-left: 0;\n  }\n\n  .landing-flow-footer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .landing-benefits-art {\n    display: none;\n  }\n\n  .landing-testimonial-row {\n    padding: 100px 16px 0;\n  }\n\n  .landing-testimonial-card,\n  .landing-job-card {\n    width: min(84vw, 320px);\n  }\n\n  .landing-footer {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
